import { RouterEffects } from '@mkp/shared/util-router';
import { LanguageEffects } from '../language.effects';
import { SeoEffects } from '../seo.effects';
import { SettingsEffects } from '../settings.effects';

export const effects = [RouterEffects, SettingsEffects, SeoEffects, LanguageEffects];
